// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { UserActivityInputUserId } from './userActivityInputUserId';
import type { UserActivityType } from './userActivityType';
import type { UserActivityInputCourseId } from './userActivityInputCourseId';
import type { UserActivityInputModuleId } from './userActivityInputModuleId';
import type { UserActivityInputTaskId } from './userActivityInputTaskId';
import type { UserActivityInputData } from './userActivityInputData';

/**
 * Stores a recent activity of a user
 */
export interface UserActivityInput {
  userId?: UserActivityInputUserId;
  timestamp?: string;
  activity: UserActivityType;
  courseId?: UserActivityInputCourseId;
  moduleId?: UserActivityInputModuleId;
  taskId?: UserActivityInputTaskId;
  data?: UserActivityInputData;
}
